<template>
  <div class="page-gearbox-oil-poster" ref="addImage">
    <div class="content" ref="capture">
      <!-- 版本banner -->
      <section class="banner">
        <img
          class="banner-bg"
          src="@/assets/backup/gearbox-poster-banner1.jpg"
          alt=""
        />
      </section>
      <!-- 车型信息 -->
      <section class="car-model">
        <div class="car-model__car-logo">
          <img :src="tempPath + vehicle_info.brand_logo_url" alt="车型logo" />
        </div>
        <p class="car-model__car-model-name">{{ car_model_name_string }}</p>
      </section>
      <!-- 油品信息 -->
      <section
        v-if="oil_info"
        :class="{
          'oil-info': true,
          'oil-info-empty':
            oil_info.transmission_fluid.length === 0 &&
            oil_info.front_reducer_oil.length === 0 &&
            oil_info.after_reducer_oil.length === 0,
        }"
      >
        <div
          class="oil-info__subtitle"
          v-if="oil_info.transmission_fluid.length > 0"
        >
          <span>变速箱油</span>
        </div>
        <div
          class="oil-info__oil-list"
          v-if="oil_info.transmission_fluid.length > 0"
        >
          <div
            class="oil-info__list-item"
            v-for="item in oil_info.transmission_fluid"
            :key="item.partId"
          >
            <img
              :src="tempPath + item.imageUrls[0]"
              alt=""
              class="oil-info__oil-img"
            />

            <div class="oil-info__oil-name double-line-ellipses">
              {{ item.nickName }}
            </div>
            <!-- <span class="oil-info__oil-price" v-if="item.sell_price">
              <span class="oil-info__unit">￥</span>
              <span class="oil-info__price">{{ item.sell_price / 100 }}/L</span>
            </span> -->
          </div>
        </div>
        <div
          class="oil-info__subtitle"
          v-if="oil_info.front_reducer_oil.length > 0"
        >
          <span>前减速器油</span>
        </div>
        <div
          class="oil-info__oil-list"
          v-if="oil_info.front_reducer_oil.length > 0"
        >
          <div
            class="oil-info__list-item"
            v-for="item in oil_info.front_reducer_oil"
            :key="item.partId"
          >
            <img
              :src="tempPath + item.imageUrls[0]"
              alt=""
              class="oil-info__oil-img"
            />
            <div class="oil-info__oil-name double-line-ellipses">
              {{ item.nickName }}
            </div>
            <!-- <span class="oil-info__oil-price" v-if="item.sell_price">
              <span class="oil-info__unit">￥</span>
              <span class="oil-info__price">{{ item.sell_price / 100 }}/L</span>
            </span> -->
          </div>
        </div>
        <div
          class="oil-info__subtitle"
          v-if="oil_info.after_reducer_oil.length > 0"
        >
          <span>后减速器油</span>
        </div>
        <div
          class="oil-info__oil-list"
          v-if="oil_info.after_reducer_oil.length > 0"
        >
          <div
            class="oil-info__list-item"
            v-for="item in oil_info.after_reducer_oil"
            :key="item.partId"
          >
            <img
              :src="tempPath + item.imageUrls[0]"
              alt=""
              class="oil-info__oil-img"
            />

            <div class="oil-info__oil-name double-line-ellipses">
              {{ item.nickName }}
            </div>
            <!-- <span class="oil-info__oil-price" v-if="item.sell_price">
              <span class="oil-info__unit">￥</span>
              <span class="oil-info__price">{{ item.sell_price / 100 }}/L</span>
            </span> -->
          </div>
        </div>
        <div
          class="empty"
          v-if="
            oil_info.transmission_fluid.length === 0 &&
            oil_info.front_reducer_oil.length === 0 &&
            oil_info.after_reducer_oil.length === 0
          "
        >
          <img class="empty-img" src="@/assets/backup/empty-oil.png" />
          <span>暂无产品推荐～</span>
        </div>
      </section>
      <!-- 养护信息 -->
      <section class="main-info">
        <div class="main-info__subtitle">养护信息</div>
        <div
          class="main-info__top-item"
          v-if="main_info.gbDescribe || main_info.datumFileNumber"
        >
          <div class="main-info__gearbox-type">
            <p class="main-info__gearbox-type-title">变速箱类型</p>
            <p class="main-info__gearbox-type-content">
              {{ main_info.gbDescribe ? main_info.gbDescribe : "--" }}
            </p>
          </div>
          <div class="main-info__gears">
            <p class="main-info__gears-title required">挡位</p>
            <p class="main-info__gears-content">
              {{ main_info.datumFileNumber ? main_info.datumFileNumber : "--" }}
            </p>
          </div>
        </div>
        <div class="main-info__item" v-if="main_info.gbNo || main_info.company">
          <div class="main-info__left">型号/厂家</div>
          <div class="main-info__right">
            {{ main_info.gbNo ? main_info.gbNo : "--" }} /
            {{ main_info.company ? main_info.company : "--" }}
          </div>
        </div>
        <div
          class="main-info__item"
          v-if="main_info.manualOil || main_info.machineOil"
        >
          <div class="main-info__left">换油量</div>
          <div class="main-info__right">
            {{
              main_info.manualOil ? "重力：" + main_info.manualOil + "L" : "--"
            }}&nbsp;&nbsp;&nbsp;
            {{
              main_info.machineOil
                ? "机器：" +
                  main_info.machineOil +
                  (main_info.machineOil * 0 === 0 ? "L" : "")
                : "--"
            }}
          </div>
        </div>
        <div class="main-info__item" v-if="main_info.frontReducer">
          <div class="main-info__left">前减速器油</div>
          <div class="main-info__right">{{ main_info.frontReducer }}L</div>
        </div>
        <div class="main-info__item" v-if="main_info.backReducer">
          <div class="main-info__left">后减速器油</div>
          <div class="main-info__right">{{ main_info.backReducer }}L</div>
        </div>
        <div class="main-info__item" v-if="main_info.gearBoxOil">
          <div class="main-info__left">齿轮箱油</div>
          <div class="main-info__right">{{ main_info.gearBoxOil }}L</div>
        </div>
        <div class="main-info__item" v-if="main_info.electUnitOil">
          <div class="main-info__left">机电单元油</div>
          <div class="main-info__right">{{ main_info.electUnitOil }}L</div>
        </div>
        <div class="main-info__item" v-if="main_info.gearboxClutch">
          <div class="main-info__left">变速箱离合器油</div>
          <div class="main-info__right">{{ main_info.gearboxClutch }}L</div>
        </div>
        <div
          class="main-info__item flex-column"
          v-if="
            main_info.gearbox_adapter && main_info.gearbox_adapter.length > 0
          "
        >
          <div class="main-info__left">接头(A)</div>
          <div class="main-info__right">
            <div class="adapter-img">
              <div
                class="adapter-img-box"
                v-for="(item, index) in main_info.gearbox_adapter"
                :key="index"
              >
                <img :src="tempPath + item.imageUrls[0]" alt="" />
                <span>{{ item.supplierCode }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          :class="{
            'main-info__item': true,
            'flex-column': main_info.accInstead === '无法更换',
          }"
          v-if="main_info.accInstead"
        >
          <div class="main-info__left">养护套装</div>
          <div class="main-info__right">
            {{ main_info.accInstead
            }}{{
              main_info.accInstead === "无法更换" ? "（" + note_text + "）" : ""
            }}
          </div>
        </div>
        <div class="main-info__item flex-column" v-if="main_info.advice">
          <div class="main-info__left">技师建议</div>
          <div class="main-info__right">{{ main_info.advice }}</div>
        </div>
      </section>
      <!-- 备注说明 -->
      <section
        class="notes"
        v-if="
          notes_imgs.length > 0 &&
          (notes_imgs[0] || notes_imgs[1] || notes_imgs[2])
        "
      >
        <div class="subtitle">备注说明</div>
        <div class="subhead" v-if="notes_imgs[0].length > 0">
          检查口/加注口/放油口
        </div>
        <div class="imgs1 imgs" v-if="notes_imgs[0].length > 0">
          <img
            v-for="item in notes_imgs[0]"
            :key="item"
            :src="tempPath + item"
            alt="检查口/加注口/放油口"
          />
        </div>
        <div class="subhead" v-if="notes_imgs[1].length > 0">接头位置（A）</div>
        <div class="imgs2 imgs" v-if="notes_imgs[1].length > 0">
          <img
            v-for="item in notes_imgs[1]"
            :key="item"
            :src="tempPath + item"
            alt="接头位置（A）"
          />
        </div>
        <div class="subhead" v-if="notes_imgs[2].length > 0">原厂换油</div>
        <div class="imgs3 imgs" v-if="notes_imgs[2].length > 0">
          <img
            v-for="item in notes_imgs[2]"
            :key="item"
            :src="tempPath + item"
            alt="原厂换油"
          />
        </div>
      </section>
      <!-- 联系客服 -->
      <section class="contact">
        <div class="left">
          <div class="subtitle">联系客服</div>
          <div class="service-time">客服时间：9:00-17:00</div>
        </div>
        <div class="right">400-687-9616</div>
      </section>
      <!-- 版本信息 -->
      <section class="app-info">
        <div class="left">
          <div class="app-name">{{ $route.query.app_name }}</div>
          <div class="service-content">
            为您的车辆提供专业的变速箱油养护信息
          </div>
        </div>
        <div class="right">
          <img :src="tempPath + $route.query.page_url_img" alt="" />
          <span class="tip">长按识别查看</span>
        </div>
      </section>
    </div>
    <!-- 保存按钮区域 -->
    <div class="save-img-box">
      <div class="button" @click="generateAndViewImg">保存至相册或分享好友</div>
      <div class="tips">
        <span>如何保存长图？ </span
        ><span
          >1. 点击按钮&nbsp; &nbsp;&nbsp;2. 长按&nbsp;&nbsp;&nbsp;3.
          点击保存或分享</span
        >
      </div>
    </div>
    <img class="target-img" @load="onImgLoad" :src="targetUrl" alt="" />
  </div>
</template>

<script>
import api from "@/apis/maintenance-api.js";
import { wxConfig } from "@/plugins/WxConfig.js";
import html2canvas from "html2canvas";
import wx from "weixin-js-sdk";
import validToken from "@/mixins/valid-token.js";
export default {
  name: "gearbox-oil-poster",
  mixins: [validToken],
  data() {
    return {
      targetUrl: "", //生成后的图片地址
      oil_info: null,
      // oil_info: {
      // transmission_fluid: {},
      // front_reducer_oil: {},
      // after_reducer_oil: {},
      // }, //油品信息
      main_info: "", //养护信息
      notes_imgs: "", //备注说明
      vehicle_info: {}, //车辆完整信息
      car_model_name_string: "", // 车型名称字符串
      is_wx: this.browser.wx,
      tempPath: `${location.origin}/crossOriginImg?referer=`,
      note_text:
        "由于变速箱结构问题，该车滤网为内置，常规保养无法拆卸更换，只有大修拆解变速箱方可进行更换。如果是干式双离合的变速箱则没有滤网。",
      imageAgent: "https://select-oil-api-new.chedianai.com/image_agent?image="
    };
  },
  async mounted() {
    console.log(
      this.$route.query.vehicle_ids,
      JSON.parse(this.$route.query.vehicle_ids)
    );
    await this.fetchOilDetailFun(); //获取油品信息
    await this.fetchVehicleDetail(); //获取车辆具体信息
    wxConfig(); //H5配置jssdk
  },
  methods: {
    /**
     * 生成并查看图片
     * @author 田月荣 <tianyuerong@vchangyi.com>
     */
    generateAndViewImg() {
      if (!this.targetUrl) {
        this.generatorImage();
      } else {
        this.previewImg();
      }
    },
    // 查看图片
    previewImg() {
      if (this.is_wx) {
        wx.previewImage({
          current: "",
          urls: [this.imageAgent+this.targetUrl], // 需要预览的图片 http 链接列表
        });
      } else {
        this.h5Preview([this.imageAgent+this.targetUrl]);
      }
    },
    /**
     * 目标图片加载完成处理器函数
     * @author 田月荣 <tianyuerong@vchangyi.com>
     */
    onImgLoad() {
      this.$loading.hide();
      this.previewImg();
    },
    /**
     * H5查看图片方法
     * @author 田月荣 <tianyuerong@vchangyi.com>
     * @param {array} imgsArr - 预览图片数组
     * @param {number} idx - 当前图片索引
     */
    h5Preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    /**
     * 使用html2canvas生成图片并上传（base64->jpg）
     * @author 田月荣 <tianyuerong@vchangyi.com>
     */
    generatorImage() {
      this.$loading.show("请稍后～");
      html2canvas(this.$refs.capture, { useCORS: true, scale: 1.9 }).then(
        (canvas) => {
          // 上传到服务器
          canvas.toBlob((blob) => {
            //以时间戳作为文件名 实时区分不同文件 按需求自己定义就好
            let filename = `${new Date().getTime()}.jpg`;
            //转换canvas图片数据格式为formData
            let file2 = new File([blob], filename, { type: "image/jpg" });
            let formData = new FormData();
            formData.append("file", file2);
            //将转换为formData的canvas图片 上传到服务器
            const uploadUrl = `${window.VUE_APP_API_ROOT}oil/common/upload`;
            this.$axios
              .post(uploadUrl, formData)
              .then((res) => {
                console.log("图片上传成功")
                this.$loading.hide();
                this.targetUrl = res.data.data.url;
              })
              .catch((e) => {
                console.log("上传失败", e);
                this.$loading.hide();
              });
          });
        }
      ).catch((e) => {
        this.$loading.hide();
        console.error("生成图片", e)
      });
    },
    async fetchOilDetailFun() {
      await this.fetchValidToken(this.fetchOilDetail, "");
    },

    /**
     * 获取变速箱油详情
     * @author 田月荣 <tianyuerong@vchangyi.com>
     */
    async fetchOilDetail() {
      if (!this.token) return;
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        parts_type: 2,
        vehicle_ids: JSON.parse(this.$route.query.vehicle_ids),
        token: this.token,
        scheme_id: scheme_id || "",
      };
      try {
        const res = await api.getModelDetail(params);
        this.$loading.hide();
        if (res.code === 0) {
          this.handleData(res, this.$route.query.key);
          this.$nextTick(() => {
            this.generateAndViewImg();
          });
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
    },
    /**
     * 过滤数据
     * @author 田月荣 <tianyuerong@vchangyi.com>
     * @param {Object} res - 变速箱油接口返回的原始数据
     * @param {Object} key - 当前选择具体key
     */
    handleData(res, key) {
      const res_data = res.data;
      /* 这里对变速箱油的数据进行整合处理，油品信息按类型返回：其中 oil_info的结构为{
				transmission_fluid :[{}] 当前key对应的油品数组
				front_reducer_oil:[] 
				after_reducer_oil:[] 
        }
        transmission_fluid-变速箱油；front_reducer_oil-前减速器油；after_reducer_oil-后减速器油
        */
      let res_temp = {
        oil_info: {
          transmission_fluid: [],
          front_reducer_oil: [],
          after_reducer_oil: [],
        },
        main_info: {
          //养护key-value
        },
        notes_imgs: [],
      };
      // 变速箱油空数据提前判断
      if (res.data.datum_list.length === 0 && res.data.parts_list.length === 0)
        return res_temp;
      // 设置油品信息
      if (key === "default") {
        res_temp.oil_info.transmission_fluid =
          res.data.parts_list &&
          res.data.parts_list.transmission_fluid &&
          res.data.parts_list.transmission_fluid[0]
            ? res.data.parts_list.transmission_fluid[0].part_detail
            : [];
        res_temp.oil_info.front_reducer_oil =
          res.data.parts_list &&
          res.data.parts_list.front_reducer_oil &&
          res.data.parts_list.front_reducer_oil[0]
            ? res.data.parts_list.front_reducer_oil[0].part_detail
            : [];
        res_temp.oil_info.after_reducer_oil =
          res.data.parts_list &&
          res.data.parts_list.after_reducer_oil &&
          res.data.parts_list.after_reducer_oil[0]
            ? res.data.parts_list.after_reducer_oil[0].part_detail
            : [];
        res_temp.main_info.gearbox_adapter =
          res.data.parts_list &&
          res.data.parts_list.transmission_fluid &&
          res.data.parts_list.transmission_fluid[0]
            ? res.data.parts_list.transmission_fluid[0].gearbox_adapter
            : []; //养护-接头信息
      } else {
        let current =
          res.data.parts_list &&
          res.data.parts_list.transmission_fluid &&
          res.data.parts_list.transmission_fluid.length > 0
            ? res.data.parts_list.transmission_fluid.find(
                (i) => i.key == this.$route.query.key
              )
            : [];
        let current_front_reducer_oil =
          res.data.parts_list &&
          res.data.parts_list.front_reducer_oil &&
          res.data.parts_list.front_reducer_oil.length > 0
            ? res.data.parts_list.front_reducer_oil.find(
                (i) => i.key == this.$route.query.key
              )
            : [];
        let current_after_reducer_oil =
          res.data.parts_list &&
          res.data.parts_list.after_reducer_oil &&
          res.data.parts_list.after_reducer_oil.length > 0
            ? res.data.parts_list.after_reducer_oil.find(
                (i) => i.key == this.$route.query.key
              )
            : [];
        res_temp.oil_info.transmission_fluid = current.part_detail
          ? current.part_detail
          : [];
        res_temp.oil_info.front_reducer_oil =
          current_front_reducer_oil.part_detail
            ? current_front_reducer_oil.part_detail
            : [];
        res_temp.oil_info.after_reducer_oil =
          current_after_reducer_oil.part_detail
            ? current_after_reducer_oil.part_detail
            : [];
        res_temp.main_info.gearbox_adapter = current.gearbox_adapter;
      }
      // 设置养护信息
      if (key === "default") {
        if (res_data.datum_list.length > 0) {
          let maintainTemp = res.data.datum_list[0].datum_detail.datumAttrs;
          res_temp.main_info = Object.assign(
            res_temp.main_info,
            maintainTemp.reduce((res, cur) => {
              res[`${cur.attrKey}`] = cur.attrValue;
              return res;
            }, {})
          );
          res_temp.main_info.datumImages =
            res_data.datum_list[0].datum_detail.datumImages;
        }
      } else {
        let temp1 = res.data.datum_list.find((i) => i.key === key);
        let temp2 = temp1.datum_detail.datumAttrs;
        res_temp.main_info = Object.assign(
          res_temp.main_info,
          temp2.reduce((res, cur) => {
            res[`${cur.attrKey}`] = cur.attrValue;
            return res;
          }, {})
        );
        res_temp.main_info.datumImages = temp1.datum_detail.datumImages;
      }
      // 整理备注说明图片
      if (res_temp.main_info.datumImages.length > 0) {
        let tempImgsArr = res_temp.main_info.datumImages;
        let temp1 = tempImgsArr
          .filter(
            (i) =>
              i.resName === "检查口" ||
              i.resName === "加注口" ||
              i.resName === "放油口"
          )
          .map((i) => i.resUrl);
        let temp2 = tempImgsArr
          .filter((i) => i.resName === "接头位置(A)")
          .map((i) => i.resUrl);
        let temp3 = tempImgsArr
          .filter((i) => i.resName === "原厂换油")
          .map((i) => i.resUrl);
        let temp4 = tempImgsArr
          .filter((i) => i.resName === "铭牌图")
          .map((i) => i.resUrl);
        temp1.length == 0 ? (temp1 = []) : "";
        temp2.length == 0 ? (temp2 = []) : "";
        temp3.length == 0 ? (temp3 = []) : "";
        temp4.length == 0 ? (temp4 = []) : "";
        res_temp.notes_imgs = [temp1, temp2, temp3, temp4];
        if (
          temp1.length == 0 &&
          temp2.length == 0 &&
          temp3.length == 0 &&
          temp4.length == 0
        ) {
          res_temp.notes_imgs = [];
        }
      }
      console.log("整理后的数据", res_temp);
      const { oil_info, main_info, notes_imgs } = res_temp;
      this.oil_info = oil_info;
      this.main_info = main_info;
      this.notes_imgs = notes_imgs;
    },
    // 获取车辆详情信息
    async fetchVehicleDetail() {
      // this.$loading.show("加载中...");
      console.log(this.$route.query);
      try {
        const res = await api.getVehicleDetailApi({
          vehicle_id: JSON.parse(this.$route.query.vehicle_ids)[0],
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.vehicle_info = res.data;
          this.car_model_name_string = `${res.data.brand_name}-${res.data.model_alias}-${res.data.factory_name}-${res.data.sales_name}-${res.data.release_year}`;
        } else {
          console.log("获取车辆详情信息异常", res);
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        error && console.log("获取车辆详情错误", error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-gearbox-oil-poster {
  padding-bottom: 230/100rem;
}
.target-img {
  width: 100%;
  height: auto;
}
.pswp__container .pswp__img {
  user-select: auto !important;
  -webkit-user-select: auto !important; 
}
.content {
  padding-bottom: 15/100rem;
  background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
}
// 版本banner
.banner {
  width: 100%;
  height: 515/100rem;
  // background: url(../../assets/backup/gearbox-poster-banner.png) no-repeat
  //   center center;
  // background-size: contain;
  position: relative;
  .banner-bg {
    position: absolute;
    left: 0;
    width: 100%;
    height: auto;
  }
}
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  .empty-img {
    width: 133/100rem;
    height: 133/100rem;
  }
  span {
    margin-top: 10/100rem;
    color: #666666;
    font-size: 24/100rem;
  }
}
//车型信息
.car-model {
  width: 585/100rem;
  // height: 150/100rem;
  margin: 0 auto;
  margin-top: 45/100rem;
  background: #ffffff;
  box-shadow: 0 14/100rem 24/100rem 0 rgba(231, 179, 7, 1);
  border-radius: 20/100rem;
  position: relative;
  padding: 0 20/100rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 29/100rem;
  &__car-logo {
    position: absolute;
    top: -52/100rem;
    left: 50%;
    transform: translateX(-50%);
    width: 104/100rem;
    height: 104/100rem;
    border-radius: 99em;
    background: #fff;
    padding-top: 7/100rem;
    display: flex;
    justify-content: center;
    img {
      width: 85/100rem;
      height: 85/100rem;
      border-radius: 99em;
    }
  }
  &__car-model-name {
    margin-top: 51/100rem;
    font-weight: 600;
    color: #000000;
    line-height: 34/100rem;
    font-size: 24/100rem;
    text-align: center;
    margin-bottom: 30/100rem;
  }
}
// 油品信息
.oil-info {
  display: flex;
  flex-direction: column;
  width: 585/100rem;
  // height: 451/100rem;
  background-color: #fff;
  margin: 0 auto;
  padding: 26/100rem;
  padding-bottom: 39/100rem;
  box-shadow: 0 14/100rem 24/100rem 0 rgba(231, 179, 7, 1);
  border-radius: 20/100rem;
  margin-bottom: 27/100rem;
  &__subtitle {
    font-weight: 600;
    color: #333333;
    font-size: 27/100rem;
    margin-bottom: 26/100rem;
    span {
      display: inline-block;
      line-height: 0.8;
      border-bottom: 10/100rem solid #f8cb14;
    }
  }
  &__oil-list {
    display: flex;
  }
  &__list-item {
    width: 166/100rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:nth-child(1),
    &:nth-child(2) {
      margin-right: 17/100rem;
    }
    .oil-info__oil-img {
      width: 166/100rem;
      height: 166/100rem;
      margin-bottom: 26/100rem;
      border-radius: 12/100rem;
      border: 1/100rem solid #eeeeee;
    }

    img {
      width: 166/100rem;
      height: 166/100rem;
      margin-bottom: 12/100rem;
    }
  }
  &__oil-name {
    width: 166/100rem;
    color: #666666;
    line-height: 34/100rem;
    font-size: 24/100rem;
    text-align: center;
    margin-bottom: 14/100rem;
  }
  &__oil-price {
    font-weight: 500;
    color: #ce4747;
  }
  &__unit {
    font-size: 24/100rem;
  }
  &__price {
    font-size: 28/100rem;
  }
}
.oil-info-empty {
  height: 307/100rem;
}
//养护信息
.main-info {
  display: flex;
  flex-direction: column;
  width: 585/100rem;
  background-color: #fff;
  margin: 0 auto;
  padding: 26/100rem;
  padding-bottom: 34/100rem;
  box-shadow: 0 14/100rem 24/100rem 0 rgba(231, 179, 7, 1);
  border-radius: 20/100rem;
  margin-bottom: 29/100rem;
  &__subtitle {
    font-weight: 600;
    color: #333333;
    font-size: 27/100rem;
    margin-bottom: 26/100rem;
  }
  &__top-item {
    height: 154/100rem;
    background: #fafafa;
    border-radius: 20/100rem;
    padding: 29/100rem 0 27/100rem 0;
    display: flex;
    justify-content: space-between;
    margin-bottom: 18/100rem;
  }
  &__gearbox-type {
    flex: 1;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #dedede;
    justify-content: center;
    align-items: center;
    &-title {
      color: #999999;
      font-size: 24/100rem;
      margin-bottom: 10/100rem;
    }
    &-content {
      line-height: 48/100rem;
      color: #000000;
      font-size: 30/100rem;
    }
  }
  &__gears {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &-title {
      color: #999999;
      font-size: 24/100rem;
      margin-bottom: 10/100rem;
    }
    &-content {
      line-height: 48/100rem;
      color: #000000;
      font-size: 34/100rem;
    }
  }
  &__item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 18/100rem 0;
    font-size: 24/100rem;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
    .main-info__right {
      flex: 1;
      margin-top: 10/100rem;
    }
  }
  &__left {
    flex-shrink: 0;
    color: #999999;
  }
  &__right {
    color: #666;
  }
  .adapter-img {
    display: flex;
    .adapter-img-box {
      margin-top: 14/100rem;
      width: 249/100rem;
      min-height: 249/100rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:first-child {
        margin-right: 15/100rem;
      }
      img {
        width: 249/100rem;
        height: 249/100rem;
        border: 2/100rem solid #eeeeee;
        border-radius: 20/100rem;
        overflow: hidden;
      }
      span {
        margin-top: 5/100rem;
        color: #666;
      }
    }
  }
}
//备注说明
.notes {
  width: 585/100rem;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 14/100rem 24/100rem 0 rgba(231, 179, 7, 1);
  border-radius: 20/100rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 29/100rem;
  .subtitle {
    margin: 26/100rem 0 24/100rem 27/100rem;
    font-weight: 600;
    color: #333333;
    line-height: 38/100rem;
    font-size: 27/100rem;
  }
  .subhead {
    margin-left: 31/100rem;
    margin-bottom: 27/100rem;
    color: #999999;
    line-height: 34/100rem;
    font-size: 24/100rem;
  }
  .imgs {
    width: 558/100rem;
    display: flex;
    flex-wrap: wrap;
    img {
      width: 249/100rem;
      height: 249/100rem;
      margin: 0 15/100rem;
      background: #ffffff;
      border-radius: 20/100rem;
      border: 2/100rem solid #eeeeee;
      margin-bottom: 31/100rem;
    }
  }
}
//联系客服
.contact {
  width: 585/100rem;
  height: 140/100rem;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 14/100rem 24/100rem 0 rgba(231, 179, 7, 1);
  border-radius: 20/100rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 29/100rem;
  align-items: center;
  padding: 0 22/100rem 0 27/100rem;
  .left {
    display: flex;
    flex-direction: column;
    .subtitle {
      font-weight: 600;
      color: #333333;
      line-height: 38/100rem;
      font-size: 27/100rem;
      margin-bottom: 10/100rem;
    }
    .service-time {
      color: #999999;
      line-height: 34/100rem;
      font-size: 24/100rem;
    }
  }
  .right {
    font-weight: 600;
    color: #333333;
    font-size: 30/100rem;
  }
}
.app-info {
  width: 585/100rem;
  height: 188/100rem;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 14/100rem 24/100rem 0 rgba(231, 179, 7, 1);
  border-radius: 20/100rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 50/100rem;
  padding: 0 12/100rem 0 24/100rem;
  .left {
    display: flex;
    flex-direction: column;
    .app-name {
      font-weight: 500;
      color: #000000;
      line-height: 38/100rem;
      font-size: 27/100rem;
      margin-top: 39/100rem;
      margin-bottom: 14/100rem;
    }
    .service-content {
      width: 331/100rem;
      color: #000000;
      line-height: 29/100rem;
      font-size: 20/100rem;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      margin-top: 13/100rem;
      width: 120/100rem;
      height: 120/100rem;
      margin-bottom: 10/100rem;
    }
    .tip {
      color: #000000;
      font-size: 20/100rem;
    }
  }
}
.save-img-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 230/100rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 32/100rem 29/100rem 0 29/100rem;
  .button {
    height: 75/100rem;
    background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
    border-radius: 38/100rem;
    font-weight: 600;
    color: #000000;
    font-size: 27/100rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26/100rem;
  }
  .tips {
    font-size: 22/100rem;
    font-weight: 400;
    color: #000000;
    display: flex;
    justify-content: space-between;
    span {
      font-weight: 500;
    }
  }
}
.required::before {
  content: "* ";
  color: #d51317;
}
canvas {
  position: absolute;
  left: -999px;
  top: 0;
}
.target-img {
  position: absolute;
  top: 0;
  left: -999px;
}
</style>
